export default "__VITE_ASSET__b0e82e6a__"